import { Cashdesk, createBlockCashdeskMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockCashdeskModel = ConfirmModalModel<Cashdesk, number, null>;

export const createBlockCashdeskModel = (): BlockCashdeskModel => {
	const blockCashdeskMutation = createBlockCashdeskMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<Cashdesk>(),
		mutation: blockCashdeskMutation,
		mapModalData: ({ id }) => id,
		successMessageKey: 'block-cashdesk.success',
	});

	return model;
};
